module.exports = __webpack_public_path__ + "img/Icon ionic-ios-add-circle-1.7783199f.svg";